// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const Check: React.FC<SvgProps> = (props) => (
  <Svg width="20" height="20" {...props} viewBox="0 0 20 20">
    <g
      id="グループ_731"
      data-name="グループ 731"
      transform="translate(3374 3181)"
    >
      <path
        id="パス_148"
        data-name="パス 148"
        d="M239.677,947.11l3.885,4.565,8.339-7.148"
        transform="translate(-3610 -4119.101)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </Svg>
);

Check.displayName = 'Check';

export default Check;
